<!-- Responsibility: Implement player profile inventory behavior for the ui/components surface.
Scope: Owns ui/components concerns only; cross-surface orchestration is excluded. -->

<player-profile-inventory>
  <section class="pp-section">
    <h5 class="pp-section-title">INVENTORY</h5>
    <div if={ props.model && props.model.inventoryTotalCount } class="pp-inventory-summary">
      Total carried: { props.model.inventoryTotalCount } · Unique entries: { props.model.inventoryUniqueCount }
    </div>
    <div each={ group in (props.model ? props.model.inventoryGroups : []) } if={ group.items.length } class="pp-inventory-group">
      <h6 class="pp-inventory-group-title">{ group.label } · { group.total }</h6>
      <div class="pp-grid categorized">
        <div each={ item in group.items } class="pp-inventory-cell">
          <item-card name={ item.name } equipped={ item.equipped } location="inventory"></item-card>
          <span if={ item.count > 1 } class="pp-inventory-count">x{ item.count }</span>
        </div>
      </div>
      <p if={ group.overflow > 0 } class="pp-overflow-note">+{ group.overflow } more { group.label.toLowerCase() } items hidden.</p>
    </div>
    <p if={ !props.model || !props.model.inventoryTotalCount } class="pp-empty">Inventory empty.</p>
  </section>

  <script>
    import ItemCard from './item-card.riot'
    export default { components: { ItemCard } }
  </script>

  <style>
    .pp-section { animation: section-in 0.5s ease both; font-size: var(--space-md); }
    .pp-section-title { color: var(--text-dim); font-size: 0.76em; letter-spacing: 0.22em; margin: 0 0 1.15em; border-bottom: 1px solid var(--border); padding-bottom: 0.55em; }
    .pp-inventory-summary { margin: 0 0 0.85em; color: var(--text-muted); font-size: calc(0.68em + 0.02rem); letter-spacing: 0.05em; font-weight: 600; line-height: 1.45; }
    .pp-inventory-group { margin-bottom: 1.05em; }
    .pp-inventory-group-title { margin: 0 0 0.6em; color: color-mix(in srgb, var(--gold) var(--alpha-subtle), var(--text-prose)); font-size: calc(0.68em + 0.02rem); letter-spacing: 0.08em; font-weight: 700; }
    .pp-grid.categorized { display: grid; grid-template-columns: repeat(auto-fill, minmax(min(100%, 13.75em), 1fr)); gap: 0.75em; }
    .pp-inventory-cell { position: relative; min-width: 0; }
    .pp-inventory-count { position: absolute; top: 0.35em; right: 0.42em; z-index: 2; border: 1px solid color-mix(in srgb, var(--gold) var(--alpha-focus), transparent); background: color-mix(in srgb, var(--gold) var(--alpha-low), var(--bg)); color: var(--gold); border-radius: 62.4375rem; font-size: calc(0.54em + 0.01rem); letter-spacing: 0.04em; font-weight: 700; line-height: 1; padding: 0.16em 0.42em; pointer-events: none; }
    .pp-overflow-note { margin: 0.48em 0 0; color: color-mix(in srgb, var(--text-muted) var(--alpha-high), #dbe8ff); font-size: calc(0.72em + 0.01rem); letter-spacing: 0.03em; line-height: 1.42; }
    .pp-empty { color: var(--text-dim); font-size: calc(0.8em + 0.02rem); margin: 0; line-height: 1.45; }
    @media (max-width: 40.625rem) { .pp-grid.categorized { grid-template-columns: 1fr; } }
  </style>
</player-profile-inventory>
